const selectors = [
  "#calendarpicker",
  "#searchfilterpicker",
  "select[id^=filter-by-]",
  "#yearpicker",
].join(", ");

const handler = (e) => (window.location.href = e.target.value);

document
  .querySelectorAll(selectors)
  .forEach((node) => node.addEventListener("input", handler));
